import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import Icon from '@ui/icons/icon';
import Button from '@ui/buttons/button/button';

type TThemePackFontVariantChangeProps = {
  selectTab: () => void;
  active: boolean;
  disabled?: boolean;
};

const ThemePackImageButton = ({ selectTab, active, disabled = false }: TThemePackFontVariantChangeProps) => {
  return (
    <>
      <Container
        background={active ? 'var(--gray-100)' : 'var(--gray-700)'}
        transitionDuration="0.2s"
        borderRadius="100px"
        height="32px"
        padding="2px"
        className="flex ai-center jc-space-between"
      >
        <Button
          clear
          backgroundColor={active ? 'var(--gray-900)' : 'var(--gray-700)'}
          hoverBackgroundColor="var(--gray-800)"
          className="flex ai-center gap-6 width-100-percent jc-space-between padding-l-8 padding-r-8"
          height={'28px'}
          borderRadius="100px"
          disabled={disabled}
          onClick={selectTab}
        >
          <Container background="transparent" className="flex ai-center gap-6">
            <Icon name={ICONS.LOGO_UPLOAD} size={12} color="var(--gray-300)" />
            <Text color="var(--gray-300)" className="C1" whiteSpace="nowrap">
              Logos
            </Text>
          </Container>
        </Button>
      </Container>
    </>
  );
};

export default ThemePackImageButton;
